export default "__VITE_ASSET__db0ae2ba__"